import { IBaseState } from '../base/base.state';
import { Schema } from '../../squidex';
import { HashMap, ID } from '@datorama/akita';
import { Content } from '../../squidex';

export class DynamicContentSchemaState implements IBaseState {
  storedIndex: { [index: number]: string; };
  lastFilter: string;
  lastOrderBy: string;
  [key: string]: any;
  code: string;
  totalCount: number;
  entities?: HashMap<Content>;
  ids?: any[];
  loading?: boolean;
  error?: any;
  active: ID;
  schema: Schema;

  constructor() { }
}
